<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">历史新老客分析
          <el-popover
            placement="right"
            width="410"
            trigger="hover"
          >
            <div>新老客：首次付款时间在查询时间段内为新客，反之为老客。</div>
            <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
          </el-popover>
        </div>
      </div>
      <div class="history_newAndOld_analysis">
        <!-- 查询条件1 --> 
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="下单时间：" required>
            <div class="my_select_time time_box">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.orderTimeStart"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div
                class="time_to_text"
              >
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.orderTimeEnd"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearOrderTime()"
              ></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            <el-radio
              v-for="item in radioList"
              :key="item.value"
              v-model="orderRadio"
              :label="item.value"
              @change="orderRadioChange"
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item label="">
            <el-button class="status_btn status_btn1" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetData">重置</el-button>
            <el-button class="exportData" @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
          style="width: 100%; margin-top: 24px;"
          v-loading="loading"
        >
          <el-table-column prop="memberType" label=" " align="center">
          </el-table-column>
          <el-table-column prop="memberNum" label="人数" align="center">
          </el-table-column>
          <el-table-column prop="memberRate" label="人数占比" align="center">
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <div>暂无任何数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 生成报表 -->
    <generate
      v-if="control"
      :control="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    />
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import { exportDataOne, getTableData } from "@/api/analysis/history_newAndOld_analysis";

export default {
  components: {
    generate,
  },

  data() {
    return {
      loading: false,
      control: false,
      form: {
        // 表单查询条件
        orderTimeStart: "",
        orderTimeEnd: "",
      },
      orderRadio: 7,
      radioList: [
        // 下单时间
        {
          label: "近7天",
          value: 7,
        },
        {
          label: "近15天",
          value: 15,
        },
        {
          label: "近30天",
          value: 30,
        },
        {
          label: "近90天",
          value: 90,
        },
        {
          label: "近180天",
          value: 180,
        },
      ],
      dimensionList: [
        // 客户类型
        {
          label: "自然日",
          value: 1,
        },
        {
          label: "自然月",
          value: 2,
        },
        {
          label: "自然年",
          value: 3,
        },
      ],
      tableData: [], // 表格数据
      exportParams: {}, // 导出参数
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, "历史新老客分析", "数据分析", "客户分析");
    this.dateInit()
    this.queryData()
  },

  methods: {
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.property == "newMemberRate") {
            sums[index] += "%";
          }
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },

    orderRadioChange(val) {
      this.form.orderTimeStart = this.getDay(-val, "-");
      this.form.orderTimeEnd = this.getDay(0, "-");
    },

    // 时间初始化
    dateInit() {
      this.form.orderTimeStart = this.getDay(-7, "-");
      this.form.orderTimeEnd = this.getDay(0, "-");
    },

    clearOrderTime() {
      this.form.orderTimeStart = "";
      this.form.orderTimeEnd = "";
    },

    // 查询
    queryData() {
      if (!this.form.orderTimeStart) {
        return this.$message.error("请选择下单开始时间")
      }
      if (!this.form.orderTimeEnd) {
        return this.$message.error("请选择下单结束时间")
      }
      this.exportParams = { ...this.form }
      this.loading = true
      getTableData(this.form).then((res) => {
        this.loading = false
        if (res.code != 1) {
          return this.$message.error(res.message || res.data.message)
        }
        this.tableData = res.data || []
      })
    },

    // 重置
    resetData() {
      this.orderRadio = 7
      this.form = {
        orderTimeStart: "",
        orderTimeEnd: "",
      }
      this.dateInit()
      this.queryData()
    },

    exportData() {
      this.control = true;
    },

    getphone(val) {
      const params = {
        ...this.exportParams,
        exportRemark: val,
      };
      exportDataOne(params).then((res) => {
        if (res.code == 1) {
          this.control = true;
        } else {
          this.$message.error(res.message || res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .history_newAndOld_analysis {
    padding: 28px;

    .time_box {
      margin-right: 20px;
    }

    .status_btn {
      width: 98px;
      background-color: #fff;
      font-size: 14px;
      margin-left: 20px;
    }

    .status_btn1 {
      color: #fe4d45;
      border-color: #fe4d45;
      margin-left: 0;
    }

    .status_btn1:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }

    .status_btn2 {
      margin-left: 8px;
      color: #333;
      border-color: #d9d9d9;
    }

    .status_btn2:hover {
      color: #fe4d45;
      border-color: #fe4d45;
      background-color: #ffe5e5;
    }

    .exportData {
      float: right;
    }

    .empty {
      padding: 40px 0;
      text-align: center;
      line-height: 30px;
    }

    .toolTipSet {
      width: 600px !important;
    }
  }
}
</style>
